// Modul 40 B4 — verschoben aus `PurchaseOrders.tsx` (Aussage und Markup unveraendert).
//
// Grund: die Bestell-Karte des Boards zeigt dieselbe Zahl im Kopf. Bliebe die Zelle in der
// Seite, importierte die Karte aus der Seite und die Seite (ueber das Board) aus der Karte.
import type { PurchaseOrderListRow } from "@/api/purchase";

/**
 * Mengen-Zelle der Uebersicht (A10) — seit B4 mit echten Werten.
 *
 * `GET /purchase/orders/` liefert `item_count` und `qty_total` fuer JEDE Bestellung, ohne
 * Zusatzparameter (P10, `1d1a1483`: eigene aggregierte Unterabfrage mit `coalesce(...,0)`).
 * Das frueher hier genannte `?with=summary` gibt es nicht — der Hinweis waere ab jetzt
 * eine falsche Auskunft an den Nutzer und ist deshalb mit umgestellt.
 *
 * Der Platzhalter bleibt, aber mit anderer Bedeutung: nicht mehr „noch nicht gebaut",
 * sondern „dieser Datensatz kam ohne die Felder" (aelteres Backend im Deploy-Fenster —
 * das Backend geht zuerst raus, praktisch sollte er also nie erscheinen).
 *
 * Worauf es beim Umstellen ankommt: **`0` und „unbekannt" sind nicht dasselbe.** Eine
 * Bestellung ohne Positionen hat jetzt wirklich `0 / 0`, und das ist eine wahre Aussage,
 * die man SEHEN muss — genau diese leeren Bestellungen waren der Anlass des Moduls. Nur
 * das fehlende Feld ist unbekannt. Deshalb steht unten eine `undefined`-Pruefung und
 * keine Falsy-Pruefung: `!0` waere wahr und wuerde die wahre Null verstecken.
 *
 * Umstellung: NUR hier — die Tabelle unten ruft die Zelle, sonst nichts.
 */
export function MengenZelle({ row }: { row: PurchaseOrderListRow }) {
  const positionen = row.item_count;
  const menge = row.qty_total;
  if (positionen === undefined || menge === undefined) {
    return (
      <span className="text-ink-2" title="Diese Bestellung kam ohne Positionszahl und Menge — die Zahl ist unbekannt, nicht null">
        –
      </span>
    );
  }
  return (
    <span>
      {positionen} <span className="text-ink-2">/</span> {menge}
    </span>
  );
}
